import React, { useState, useEffect, useRef } from "react";
import { API_BASE } from "../api/config";
import { FaTable, FaSearch } from "react-icons/fa";
import { useNavigate,useParams,useSearchParams  } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // ✅ import auth




function SelfOrderByTable() {
  const { username } = useAuth(); // ✅ get branch
  const [tables, setTables] = useState([]);
  const [selectedTable, setSelectedTable] = useState(null);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [items, setItems] = useState([]);
  const [kotItems, setKotItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [branchInfo, setBranchInfo] = useState(null); // ✅ store branch info
  const searchRef = useRef(null); // ✅ ref for search input
  const navigate = useNavigate();
  const [showKotDetails, setShowKotDetails] = useState(false);
  const [mobileKotOpen, setMobileKotOpen] = useState(false);
  
  const [showOtpPopup, setShowOtpPopup] = useState(true);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const DUMMY_OTP = "1234";
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

    const { branch } = useParams(); // ✅ works now

  
  const generateOrderRef = () => {
  const now = new Date();

  const Y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  const H = String(now.getHours()).padStart(2, "0");
  const i = String(now.getMinutes()).padStart(2, "0");
  const s = String(now.getSeconds()).padStart(2, "0");

  const random = Math.floor(Math.random() * (100 - 10 + 1)) + 10; // 10–100

  return `${Y}${m}${d}${H}${i}${s}${random}`;
  };

	const orderRef = generateOrderRef();
	
	const handleVerifyOtp = () => {
  if (otp === DUMMY_OTP) {
    setShowOtpPopup(false);
    setOtp("");
    setOtpError("");
  } else {
    setOtpError("Invalid OTP");
  }
};



  // ✅ Focus search input when category or table changes
  useEffect(() => {
    if (searchRef.current) {
      searchRef.current.focus();
    }
  }, [selectedCategory, selectedTable]);

  // ✅ Fetch tables
  const fetchTables = async () => {
    try {
      const response = await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&table=get_active_table&transac=get&condition=get_status_active_tables&branch=${branch}`
      );
      const data = await response.json();
      const mappedTables = data.map((t, idx) => ({
        id: idx + 1,
        name: t.table_name,
        seats: 4,
        status: t.table_booked_status === "1" ? "Occupied" : "Available",
      }));
      setTables(mappedTables);
    } catch (error) {
      console.error("Error fetching tables:", error);
    }
  };

  // ✅ Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(
          `${API_BASE}?key=dzital_key&pswd=Hibujji@123&table=groups&transac=get&condition=get_active_groups&branch=${branch}`
        );
        const data = await res.json();
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, [branch]);

  // ✅ Fetch items
  useEffect(() => {
    const fetchItems = async () => {
      try {
        const res = await fetch(
          `${API_BASE}?key=dzital_key&pswd=Hibujji@123&table=items&transac=get&condition=get_active_items&branch=${branch}`
        );
        const data = await res.json();
        setItems(data);
      } catch (error) {
        console.error("Error fetching items:", error);
      }
    };
    fetchItems();
  }, [branch]);

  // ✅ Fetch tables on mount
  useEffect(() => {
    fetchTables();
  }, [branch]);

  // ✅ Fetch branch info for printing
  useEffect(() => {
    const fetchBranchInfo = async () => {
      try {
        const res = await fetch(
          `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=branches&condition=get_branch_det&branch=${branch}`
        );
        const data = await res.json();
        if (data && data.length > 0) {
          setBranchInfo(data[0]);
        }
      } catch (error) {
        console.error("Error fetching branch info:", error);
      }
    };
    fetchBranchInfo();
  }, [branch]);

  // ✅ Filter items
  const filteredItems = searchTerm
    ? items.filter((item) =>
        item.item_name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : selectedCategory
    ? items.filter((item) => item.group === selectedCategory.item_name)
    : [];

  // ----------------- KOT Functions -----------------
  const handleSelectTable = (table) => {
	  if (showOtpPopup) return; // 🔒 block before OTP
    setSelectedTable(table);
    setSelectedCategory(null);
    setKotItems([]);
    setSearchTerm("");
    setSelectedItem(null);
  };

  const handleSelectCategory = (category) => {
    setSelectedCategory(category);
    setSearchTerm("");
    setSelectedItem(null);
  };

  const handleAddItem = (item) => {
    setSelectedItem(item.id);
    const existing = kotItems.find((i) => i.id === item.id);
    if (existing) {
      setKotItems(
        kotItems.map((i) =>
          i.id === item.id ? { ...i, quantity: i.quantity + 1 } : i
        )
      );
    } else {
      setKotItems([
        ...kotItems,
        {
          ...item,
          quantity: 1,
          name: item.item_name,
          price: item.item_price,
          group_name: item.group,
        },
      ]);
    }

    // ✅ Clear search & focus back to input
    setSearchTerm("");
    if (searchRef.current) {
      searchRef.current.focus();
    }
  };

  const handleIncrease = (item) => {
    setKotItems(
      kotItems.map((i) =>
        i.id === item.id ? { ...i, quantity: i.quantity + 1 } : i
      )
    );
  };

  const handleDecrease = (item) => {
    setKotItems(
      kotItems
        .map((i) =>
          i.id === item.id ? { ...i, quantity: i.quantity - 1 } : i
        )
        .filter((i) => i.quantity > 0)
    );
  };

  const handleFinalizeKOT = async () => {
    if (!selectedTable || kotItems.length === 0) {
      alert("Select table and add items first!");
      return;
    }

    setProcessing(true);

    try {
      const payload = kotItems.map((item) => ({
        table_name: selectedTable.name,
        item_name: item.name,
        item_qty: item.quantity,
        group_name: item.group_name,
        item_price: item.price,
        branch: branch,
      }));

      await fetch(
        `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=insert_kot&username=${username}&branch=${branch}&order_ref=${orderRef}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
	  
	   // 2️⃣ FETCH day_srno using order_ref
    const srRes = await fetch(
      `${API_BASE}?key=dzital_key&pswd=Hibujji@123&transac=get&table=get_kot_by_order_ref&order_ref=${orderRef}`
    );
    const srData = await srRes.json();
    const daySrNo = srData?.[0]?.day_srno || "—";
	  
	      const now = new Date();
    const dateTimeStr = now.toLocaleString();

   

   // 🔁 RESET EVERYTHING
  setSelectedTable(null);
  setSelectedCategory(null);
  setKotItems([]);
  setSearchTerm("");
  setSelectedItem(null);
  setProcessing(false);

  // 🔐 SHOW OTP AGAIN
  setShowOtpPopup(true);

  // ✅ SHOW SUCCESS MESSAGE
  setShowSuccessPopup(true);

  fetchTables();

    

    } catch (error) {
      console.error("Error sending KOT to server:", error);
      setProcessing(false);
    }
  };

  return (
      <div className="min-h-screen bg-gradient-to-br from-black via-blue-950 to-black text-white flex flex-col md:flex-row gap-4 p-3 relative pb-48 md:pb-4 overflow-y-auto">
		 {/* 🔷 Header Only (No Menu) */}
    <div className="sticky top-0 z-40 bg-black/90 backdrop-blur border-b border-blue-900 px-4 py-3">
      <h1 className="text-xl md:text-2xl font-bold text-center text-blue-400">
        {branchInfo?.name || "Company Name"}
      </h1>
      <p className="text-center text-xs text-gray-400">
        {branchInfo?.address || ""}
      </p>
    </div>
        {processing && (
          <div className="absolute inset-0 bg-black/80 flex items-center justify-center z-50">
            <div className="bg-blue-950 text-white px-6 py-4 rounded-lg shadow-lg text-center animate-pulse">
              <h2 className="text-xl font-bold mb-2">Processing...</h2>
              <p className="text-gray-300">Please wait a moment.</p>
            </div>
          </div>
        )}

        {/* Left Panel */}
        <div className="flex-1 flex flex-col gap-4">
          {!selectedTable ? (
            <>
              <h1 className="text-2xl font-bold">Select Table 🪑</h1>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 overflow-y-auto max-h-[80vh] pb-2">
                {tables.map((table) => (
                  <div
                    key={table.id}
                    className={`p-3 rounded-lg shadow cursor-pointer text-center transition ${
                      table.status === "Available"
                        ? "bg-blue-950 hover:bg-blue-900 text-white"
                        : "bg-black/80 border border-red-500 text-red-300"
                    }`}
                    onClick={() => handleSelectTable(table)}
                  >
                    <h2 className="text-sm font-semibold mb-1">{table.name}</h2>
                    <div className="flex justify-center mb-1">
                      <FaTable className="text-xl" />
                    </div>
                    <p
                      className={`text-xs font-medium ${
                        table.status === "Available"
                          ? "text-green-400"
                          : "text-red-400"
                      }`}
                    >
                      {table.status}
                    </p>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <>
			
			  <button
                className="px-3 py-1 bg-blue-700 rounded hover:bg-blue-800 w-full md:w-auto"
                onClick={() => setSelectedTable(null)}
              >
                Back to Tables
              </button>
			 
			
              {/* Categories */}
              <div className="grid grid-cols-3 sm:grid-cols-5 gap-2 overflow-x-auto max-h-[150px] pb-1">
                {categories.map((cat) => {
                  const count = items.filter(
                    (item) => item.group === cat.item_name
                  ).length;
                  return (
                    <button
                      key={cat.id}
                      className={`flex flex-col items-center p-2 rounded text-sm font-semibold transition ${
                        selectedCategory?.item_name === cat.item_name
                          ? "bg-black text-blue-400 border border-blue-500"
                          : "bg-blue-950 text-white hover:bg-blue-800"
                      }`}
                      onClick={() => handleSelectCategory(cat)}
                    >
                      <span>{cat.item_name}</span>
                      <span className="text-xs text-gray-300 mt-1">
                        ({count})
                      </span>
                    </button>
                  );
                })}
              </div>

              {/* Search */}
              <div className="relative mb-3">
                <input
                  ref={searchRef}
                  type="text"
                  placeholder="Search items..."
                  className="w-full pl-7 pr-2 p-2 rounded bg-black/70 text-white border border-gray-700"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
              </div>
			  
			   {kotItems.length > 0 && (
			    <div className="md:hidden">
			  <button
                className="px-3 py-1 bg-orange-700 rounded hover:bg-orange-800 w-full md:w-auto"
                onClick={() => setShowKotDetails(true)}
              >
                Show Order ({kotItems.reduce((acc, i) => acc + i.quantity, 0)} items - ₹
          {kotItems
            .reduce((acc, i) => acc + i.quantity * parseFloat(i.price || 0), 0)
            .toFixed(2)})
              </button>
			  </div>
			)}

              {/* Items */}
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 overflow-y-auto max-h-[300px] pb-2">
                {filteredItems.map((item) => {
                  const isSelected = selectedItem === item.id;
                  return (
                    <div
                      key={item.id}
                      className={`flex flex-col items-center justify-center p-2 rounded shadow cursor-pointer transition min-h-[70px] ${
                        isSelected
                          ? "bg-black text-blue-400 border border-blue-500"
                          : "bg-blue-950 text-white hover:bg-blue-800"
                      }`}
                      onClick={() => handleAddItem(item)}
                    >
                      <h3 className="font-semibold text-center text-sm">
                        {item.item_name}
                      </h3>
                      <span className="text-xs">
                        ₹{parseFloat(item.item_price).toFixed(2)}
                      </span>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>

        {/* Right Panel - KOT */}
<div className="hidden md:block w-2/5 bg-black/70 p-4 rounded-lg shadow-md h-fit max-h-[calc(100vh-50px)] overflow-y-auto">

          <h2 className="text-xl font-bold mb-3">
            {selectedTable ? `KOT - ${selectedTable.name}` : "KOT"}
          </h2>
          {kotItems.length === 0 ? (
            <p className="text-gray-300">No items added yet.</p>
          ) : (
            <>
              {kotItems.map((item) => (
                <div
                  key={item.id}
                  className="flex justify-between items-center mb-2 bg-blue-950/70 p-3 rounded"
                >
                  <span>{item.name}</span>
                  <div className="flex items-center gap-2">
                    <button
                      className="px-2 bg-red-600 rounded"
                      onClick={() => handleDecrease(item)}
                    >
                      -
                    </button>
                    <span>{item.quantity}</span>
                    <button
                      className="px-2 bg-green-600 rounded"
                      onClick={() => handleIncrease(item)}
                    >
                      +
                    </button>
                  </div>
                </div>
              ))}
              <hr className="my-3 border-gray-600" />
              <div className="flex justify-between font-bold mb-3">
                <span>Total Items:</span>
                <span>
                  {kotItems.reduce((acc, i) => acc + i.quantity, 0)}
                </span>
              </div>
              <button
                onClick={handleFinalizeKOT}
                disabled={processing}
                className={`w-full px-4 py-2 font-bold rounded ${
                  processing
                    ? "bg-gray-600 cursor-not-allowed"
                    : "bg-blue-700 hover:bg-blue-800"
                }`}
              >
                {processing ? "Processing..." : "Finalize & Print KOT"} ₹
          {kotItems
            .reduce((acc, i) => acc + i.quantity * parseFloat(i.price || 0), 0)
            .toFixed(2)}
              </button>
            </>
          )}
        </div>
		{/* Mobile Sticky Cart Footer */}
 

  {/* Mobile Slide-Up KOT Panel */}
  {showKotDetails && (
    <div className="fixed inset-0 bg-black/80 flex flex-col justify-end z-50">
      <div className="bg-gray-900 p-4 rounded-t-2xl max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-3">
          <h2 className="text-lg font-bold">KOT Details</h2>
          <button
            className="text-gray-300 hover:text-white"
            onClick={() => setShowKotDetails(false)}
          >
            ✕
          </button>
        </div>
        {kotItems.map((item) => (
          <div
            key={item.id}
            className="flex justify-between items-center mb-2 bg-blue-950/70 p-3 rounded"
          >
            <span>{item.name}</span>
            <div className="flex items-center gap-2">
              <button
                className="px-2 bg-red-600 rounded"
                onClick={() => handleDecrease(item)}
              >
                -
              </button>
              <span>{item.quantity}</span>
              <button
                className="px-2 bg-green-600 rounded"
                onClick={() => handleIncrease(item)}
              >
                +
              </button>
            </div>
          </div>
        ))}
        <hr className="my-3 border-gray-600" />
        <div className="flex justify-between font-bold mb-3">
          <span>Total Items:</span>
          <span>
            {kotItems.reduce((acc, i) => acc + i.quantity, 0)}
          </span>
        </div>
        <button
          onClick={handleFinalizeKOT}
          disabled={processing}
          className={`w-full px-4 py-2 font-bold rounded ${
            processing
              ? "bg-gray-600 cursor-not-allowed"
              : "bg-blue-700 hover:bg-blue-800"
          }`}
        >
          {processing ? "Processing..." : "Finalize & Print KOT"} ₹
          {kotItems
            .reduce((acc, i) => acc + i.quantity * parseFloat(i.price || 0), 0)
            .toFixed(2)}
        </button>
      </div>
    </div>
  )}{/* 🔐 OTP POPUP */}
{showOtpPopup && (
  <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center">
    <div className="bg-gray-900 p-6 rounded-lg w-80 shadow-xl">
      <h2 className="text-xl font-bold text-center mb-4 text-blue-400">
        Enter OTP
      </h2>

      <input
        type="password"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
        placeholder="Enter OTP"
        className="w-full p-2 mb-2 rounded bg-black text-white border border-gray-700 text-center tracking-widest"
      />

      {otpError && (
        <p className="text-red-400 text-sm text-center mb-2">
          {otpError}
        </p>
      )}

      <button
        onClick={handleVerifyOtp}
        className="w-full bg-blue-700 hover:bg-blue-800 py-2 rounded font-bold"
      >
        Verify OTP
      </button>

      <p className="text-xs text-gray-400 text-center mt-3">
        Demo OTP: <b>1234</b>
      </p>
    </div>
  </div>
)}
{/* ✅ ORDER SUCCESS POPUP */}
{showSuccessPopup && (
  <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center">
    <div className="bg-gray-900 p-6 rounded-lg w-80 shadow-xl text-center">
      <h2 className="text-2xl font-bold text-green-400 mb-3">
        ✅ Order Placed
      </h2>

      <p className="text-gray-300 mb-4">
        Your order has been placed successfully.
      </p>

      <button
        onClick={() => setShowSuccessPopup(false)}
        className="w-full bg-green-600 hover:bg-green-700 py-2 rounded font-bold"
      >
        OK
      </button>
    </div>
  </div>
)}

      </div>
  );
}

export default SelfOrderByTable;
